import React from "react";
import { Container, Typography } from "@mui/material";
import MPITable from "./view";

const MPI = ({ userRole }) => {
  return (
    <Container>
      <Typography variant={"h3"}>MPI</Typography>
      <MPITable userRole={userRole} />
    </Container>
  );
};

export default MPI;
